import _keys from 'lodash/keys'
import { attributes, parse } from '../../imports'
import { SEVERITY_INFO } from './constants'

// const autoIncrementingId = 0

// function getNextId() {
//     // Just to make sure we never reach integer overflow
//     autoIncrementingId = autoIncrementingId < 10000 ? autoIncrementingId + 1 : 0
//     return autoIncrementingId
// }

export function createToast(options, queue = null) {
    const now = +new Date()
    const basicOptions = {
        locales: _keys(attributes.languages),
        // iid: getNextId(),
        created: now,
        updated: now,
        dismissed: null,
    }

    if (queue != null) {
        basicOptions.queue = queue
    } else {
        basicOptions.queue = 'normal'
    }

    let input = {}
    if (typeof options === 'string') {
        input = { content: options }
    } else {
        input = { ...options }
    }

    return {
        ...input,
        ...basicOptions,
    }
}

// DJB2 Hashing Algorithm
// https://stackoverflow.com/a/7616484/404479
// This function is used to get "unique" notificationId based on
// a string
export function toHashCode(input) {
    let hash = 0
    let i
    let chr
    if (input.length === 0) return hash
    for (i = 0; i < input.length; i++) {
        chr = input.charCodeAt(i)
        hash = (hash << 5) - hash + chr // eslint-disable-line
        // eslint-disable-next-line
        hash |= 0 // Convert to 32bit integer
    }
    // eslint-disable-next-line
    return `0000000${(hash >>> 0).toString(16)}`.substr(-8)
}

export function createMessage(baseMessage, message) {
    // Start by seting all values to default
    const result = {
        ...baseMessage,
        queue: 'normal',
        isMessage: true,
        tag: { ...message },
        localized: parse(message),
        id: message.id,
        severity: SEVERITY_INFO,
    }

    result.title = result.localized.en.title
    result.content = result.localized.en.content

    // If id is missing, create one from a hash of the message in english
    if (result.id == null || result.id === '') {
        result.id = toHashCode(result.content)
    }

    return result
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/toasts/api.js